import { getEnvValue } from "../utils/env";

let VITE_API_URL_VERSION: string;
try {
  VITE_API_URL_VERSION = getEnvValue("VITE_API_URL_VERSION");
} catch {
  VITE_API_URL_VERSION = "v1";
}

let VITE_API_URL_VERSION_V2: string;
try {
  VITE_API_URL_VERSION_V2 = getEnvValue("VITE_API_URL_VERSION_V2");
} catch {
  VITE_API_URL_VERSION_V2 = "v2";
}

export const rootCallEvaluationEndpoint = `api/${VITE_API_URL_VERSION}/call_evaluation`;
export const rootNotificationEndpoint = `api/${VITE_API_URL_VERSION}/notification_center`;
export const rootAccountsEndpoint = `api/${VITE_API_URL_VERSION}/accounts`;
export const rootBaseEndpoint = `api/${VITE_API_URL_VERSION}/base`;
export const rootAuthEndpoint = "api/accounts";
export const rootAccessMgmtEndpoint = `api/${VITE_API_URL_VERSION}/access_mgmt`;
export const rootCallEvaluationV2Endpoint = `api/${VITE_API_URL_VERSION_V2}/call_evaluation`;
export const rootOrganizationHierarchyEndpoint = `api/${VITE_API_URL_VERSION}/organization_hierarchy`;
export const rootEmployeeManagementEndpoint = `api/${VITE_API_URL_VERSION}/employee_management`;
export const rootAnalyticsEndpoint = `api/${VITE_API_URL_VERSION}/analytics`;
export const rootNanoLearningEndpoint = `api/v1/nano_learning`;

export const API = {
  loginEndpoint: `${rootAccountsEndpoint}/login/`,
  logoutEndpoint: `${rootAccountsEndpoint}/logout/`,
  user: `${rootAccountsEndpoint}/user-detail/`,
  userInvite: `${rootAccountsEndpoint}/user-invite/`,
  inviteVerification: `${rootAccountsEndpoint}/invite-verification/`,
  forgotPasswordEndpoint: `${rootAccountsEndpoint}/forgot-password/`,
  refreshAccessTokenEndpoint: `${rootAccountsEndpoint}/token/refresh/`,
  userDetails: `${rootAccountsEndpoint}/user-detail/`,
  template: `${rootCallEvaluationEndpoint}/template/`,
  template_lookup: `${rootCallEvaluationEndpoint}/template-lookup/`,
  evaluation_list: `${rootCallEvaluationEndpoint}/list/`,
  reassign_auditor_evaluations: `${rootCallEvaluationEndpoint}/reassign-auditor-evaluations/`,
  evaluation_details: `${rootCallEvaluationEndpoint}/details/`,
  speech_translation: `${rootCallEvaluationEndpoint}/speech-translation/`,
  download_summary_report: `${rootCallEvaluationEndpoint}/download-comment/`,
  change_status: `${rootCallEvaluationEndpoint}/change_status/`,
  call_evaluation_dashboard: `${rootCallEvaluationEndpoint}/call_evaluation_dashboard/`,
  evaluation_dashboard_failed_category_count: `${rootCallEvaluationEndpoint}/failed_category_count/`,
  workflow_kpis: `${rootCallEvaluationEndpoint}/workflow-kpis/`,
  export_failed_category_calls: `${rootCallEvaluationEndpoint}/failed_category_calls_export/`,
  failed_category_calls: `${rootCallEvaluationEndpoint}/failed_category_calls/`,
  agent_leader_board: `${rootCallEvaluationEndpoint}/agent-leader-board/`,
  agent_ranking: `${rootCallEvaluationV2Endpoint}/agent-ranking/`,
  agent_ranking_configuration: `${rootCallEvaluationV2Endpoint}/agent-ranking-configuration/`,
  outlier_agent_report: `${rootCallEvaluationEndpoint}/outlier_agent_report/`,
  campaigns: `${rootCallEvaluationEndpoint}/campaigns/`,
  notifications: `${rootNotificationEndpoint}/notifications/`,
  markNotificationRead: `read/`,
  clearNotificationRead: `clear/`,
  manual_review: `${rootCallEvaluationEndpoint}/manual_review/`,
  services: `${rootCallEvaluationEndpoint}/services/`,
  entity_list: `${rootAccountsEndpoint}/entity_list/`,
  entity_feature_showHideFlag: `${rootBaseEndpoint}/entity-feature/`,
  evaluation_type: `${rootCallEvaluationEndpoint}/lookup/evaluation-type`,
  category_list: `${rootCallEvaluationEndpoint}/category-list/`,
  entity_integration_partner: `${rootBaseEndpoint}/entity-integration-partner/`,
  entity_integration_partners: `${rootBaseEndpoint}/entity-integration-partners/list/`,
  entity_integration_partners_configurations: `${rootBaseEndpoint}/entity-integration-partners/configurations/`,
  capabilities: `${rootBaseEndpoint}/lookups/capabilities/`,
  integration_partners: `${rootBaseEndpoint}/integration-partners/`,
  integration_partner_configurations: `${rootBaseEndpoint}/integration-partner-configurations/`,
  integration_partner_by_entityid: `${rootBaseEndpoint}/integration-partners-by-entityid/`,
  remote_push_configs: `${rootBaseEndpoint}/remote-push-configs/`,
  remote_push_config_secret_key: `${rootBaseEndpoint}/remote-push-config/:internal_id/secret-key/`,
  remote_push_config_revoke: `${rootBaseEndpoint}/remote-push-config/:internal_id/revoke/`,
  remote_push_config_recording_audit: `${rootBaseEndpoint}/ingest-recording-audit/:internal_id/`,
  recording_status: `${rootBaseEndpoint}/recording-status/`,
  manage_user: `${rootAccountsEndpoint}/users/`,
  location: `${rootAccountsEndpoint}/location_list/`,
  export: `${rootAccountsEndpoint}/export-user-list/`,
  delete: `${rootAccountsEndpoint}/deactivate_user/`,
  upload: `${rootAccountsEndpoint}/user-upload/`,
  country_list: `${rootAccountsEndpoint}/country_list/`,
  state_list: `${rootAccountsEndpoint}/state_list/`,
  get_recording_fields_info: `${rootCallEvaluationEndpoint}/get-recording-fields-info/`,
  conversational_tags: `${rootCallEvaluationEndpoint}/conversational_tags/`,
  campaign_list: `${rootCallEvaluationEndpoint}/campaigns/`,
  role_list: `${rootAccessMgmtEndpoint}/role-list/`,
  department_list: `${rootAccountsEndpoint}/department_list/`,
  create_user: `${rootAccountsEndpoint}/create_user/`,
  edit_user: `${rootAccountsEndpoint}/user_by_id/`,
  update_user_details: `${rootAccountsEndpoint}/edit_user/`,
  connection_check: `${rootBaseEndpoint}/connection-check/`,
  topic_sense: `${rootCallEvaluationEndpoint}/topic-sense/`,
  // sentiment Analysis Per call endpoints
  sentiment_word_cloud: `${rootCallEvaluationEndpoint}/word-clouds/`,
  speaker_emotions: `${rootCallEvaluationEndpoint}/speaker-emotions/`,
  sentiment_analysis: `${rootCallEvaluationEndpoint}/sentiment_analysis/`,
  sentiment_timing: `${rootCallEvaluationEndpoint}/sentiment_timing/`,
  emotion_analysis: `${rootCallEvaluationEndpoint}/emotion_analysis/`,
  // branding endpoints
  theme: `${rootAccountsEndpoint}/theme/`,
  branding: `${rootAccountsEndpoint}/branding/`,
  changePassword: `${rootAccountsEndpoint}/change-password/`,
  // create entity endpoints
  create_entity_scale_rating: `${rootAccountsEndpoint}/entity-scale-rating/`,
  get_entity_scale_rating: `${rootAccountsEndpoint}/entity-scale-ratings/`,
  update_entity_scale_rating: `${rootAccountsEndpoint}/update-entity-scale-rating/`,
  call_volume_chart: `${rootCallEvaluationEndpoint}/call-volume/`,
  average_call_score_chart: `${rootCallEvaluationEndpoint}/average-call-score/`,
  top_violations_by_category: `${rootCallEvaluationEndpoint}/top_violations_by_categories/`,
  // Customer Insights report
  customer_insights_kpis: `${rootCallEvaluationEndpoint}/customer-insights/kpis/`,
  disposition_by_location: `${rootCallEvaluationEndpoint}/customer-insights/disposition-by-location/`,
  purpose_of_call_distribution: `${rootCallEvaluationEndpoint}/customer-insights/purpose-of-call-distribution/`,
  evaluation_details_audio_path: `${rootCallEvaluationEndpoint}/audio/get-path/`,
  create_entity: `${rootAccountsEndpoint}/create_entity_with_owner/`,
  agent: `${rootAccountsEndpoint}/user_list/agent/`,
  uscs_opportunities_list: `${rootCallEvaluationV2Endpoint}/uscs_opportunities_list/`,
  call_manual_review: `${rootCallEvaluationV2Endpoint}/manual_review/`,
  agent_acknowledgement: `${rootCallEvaluationV2Endpoint}/manual_review/agent_acknowledgement/`,
  call_evaluation_agents_list: `${rootCallEvaluationEndpoint}/call-evaluation-agents-list/`,
  call_evaluation_agents_list_v2: `${rootCallEvaluationV2Endpoint}/call-evaluation-agents-list/`,
  resetPassword: `${rootAccountsEndpoint}/reset-password/`,
  forgot_password: `${rootAccountsEndpoint}/forgot-password/`,
  updatePassword: `${rootAccountsEndpoint}/set-password/`,
  renewPassword: `${rootAccountsEndpoint}/renew-password/`,
  onboardUser: `${rootAccountsEndpoint}/onboard-user/`,
  // Organization Hierarchy APIS
  organization_hierarchy_relationships: `${rootOrganizationHierarchyEndpoint}/relationships/`,
  organization_hierarchy_configuration: `${rootOrganizationHierarchyEndpoint}/configuration/`,
  organization_hierarchy_preview_changes: `${rootOrganizationHierarchyEndpoint}/preview-changes`,
  organization_hierarchy_access_permissions: `${rootOrganizationHierarchyEndpoint}/access-permissions/`,
  organization_hierarchy_bulk_import: `${rootOrganizationHierarchyEndpoint}/bulk-import/`,
  organization_hierarchy_download_template: `${rootOrganizationHierarchyEndpoint}/download-template/`,
  organization_hierarchy_employees: `${rootOrganizationHierarchyEndpoint}/relationships/employees/`,
  organization_hierarchy_temporal_preview: `${rootOrganizationHierarchyEndpoint}/temporal-preview/`,
  organization_hierarchy_conflicts: `${rootOrganizationHierarchyEndpoint}/conflicts/`,
  organization_hierarchy_lookups_hierarchy_types: `${rootOrganizationHierarchyEndpoint}/lookups/hierarchy-types/`,
  organization_hierarchy_lookups_relationship_types: `${rootOrganizationHierarchyEndpoint}/lookups/relationship-types/`,
  organization_hierarchy_lookups_conflict_resolution_strategies: `${rootOrganizationHierarchyEndpoint}/lookups/conflict-resolution-strategies/`,
  organization_hierarchy_screens: `${rootOrganizationHierarchyEndpoint}/screens/`,
  organization_hierarchy_screen_configs: `${rootOrganizationHierarchyEndpoint}/hierarchy-screen-configs/`,
  // Employee Management API endpoints
  employees: `${rootEmployeeManagementEndpoint}/employees/`,
  employees_list_rank: `${rootEmployeeManagementEndpoint}/employees-list/rank/`,
  employees_bulk_upload: `${rootEmployeeManagementEndpoint}/employees-bulk-upload/`,
  preview_bulk_import: `${rootEmployeeManagementEndpoint}/employees/bulk_import/`,
  convert_employee_to_user: `${rootEmployeeManagementEndpoint}/employees/`,
  export_employees: `${rootEmployeeManagementEndpoint}/employees/export/`,
  employee_choices: `${rootEmployeeManagementEndpoint}/employees/choices/`,
  employee_agent_list: `${rootEmployeeManagementEndpoint}/employees/agent/`,
  employee_supervisor_list: `${rootEmployeeManagementEndpoint}/employees/qa-supervisor/`,
  // Employee Invitation API endpoints
  employee_invitation_list: `${rootEmployeeManagementEndpoint}/invitations/`,
  employee_invitation_detail: `${rootEmployeeManagementEndpoint}/invitations/detail/`,
  create_employee_invitation: `${rootEmployeeManagementEndpoint}/invitations/create/`,
  resend_employee_invitation: `${rootEmployeeManagementEndpoint}/invitations/resend/`,
  cancel_employee_invitation: `${rootEmployeeManagementEndpoint}/invitations/cancel/`,
  invitation_stats: `${rootEmployeeManagementEndpoint}/invitations/stats/`,
  validate_invitation_token: `${rootEmployeeManagementEndpoint}/invitations/validate-token/`,
  accept_invitation: `${rootEmployeeManagementEndpoint}/invitations/accept/`,
  // Entity APIS
  entity_update: `${rootAccountsEndpoint}/entities/update/`,
  // Tenant Settings API endpoints
  tenant_employee_settings: `${rootBaseEndpoint}/tenant-employee-settings/`,
  update_tenant_employee_settings: `${rootBaseEndpoint}/tenant-employee-settings/update/`,
  date_time_locations_list: `${rootAccountsEndpoint}/locations-list/`,
  date_time_locations: `${rootAccountsEndpoint}/locations/`,
  // Employee Attribute Definition API endpoints
  employee_attributes: `${rootEmployeeManagementEndpoint}/employee-attributes/`,
  employee_attribute_validate: `${rootEmployeeManagementEndpoint}/employee-attributes/validate/`,
  employee_audit_test_action: `${rootEmployeeManagementEndpoint}/audit/test-action/`,
  employee_anonymization_candidates: `${rootEmployeeManagementEndpoint}/anonymization/candidates/`,
  employee_anonymization_anonymize: `${rootEmployeeManagementEndpoint}/anonymization/anonymize/`,
  employee_data_export: `${rootEmployeeManagementEndpoint}/data/export/`,
  employee_compliance_reports_generate: `${rootEmployeeManagementEndpoint}/compliance/reports/generate/`,
  employee_compliance_reports: `${rootEmployeeManagementEndpoint}/compliance/reports/`,
  // Nano Learning API endpoints
  nano_learning_list: `${rootNanoLearningEndpoint}/nano-learning/`,
  nano_learning_detail: `${rootNanoLearningEndpoint}/detail-nano-learning/:internal_id/`,
  nano_learning_create: `${rootNanoLearningEndpoint}/nano-learning/`,
  nano_learning_update: `${rootNanoLearningEndpoint}/nano-learning/:internal_id/`,
  nano_learning_delete: `${rootNanoLearningEndpoint}/nano-learning/:internal_id/`,
  nano_learning_agent_view: `${rootNanoLearningEndpoint}/nano-learning-agent-view/`,
  nano_learning_categories_by_template: `${rootNanoLearningEndpoint}/categories-by-template/`,
  learning_categories: `${rootNanoLearningEndpoint}/learning-categories/`,
  nano_learning_library: `${rootNanoLearningEndpoint}/nano-learning-library/`,
  nano_learning_category_content: `${rootNanoLearningEndpoint}/category-content/:template_id/:category_id/`,
  nano_learning_question_content: `${rootNanoLearningEndpoint}/question-content/:module_id/:category_id/`,
  nano_learning_question_content_detail: `${rootNanoLearningEndpoint}/question-content-detail/:content_id/`,
  nano_learning_question_content_by_template: `${rootNanoLearningEndpoint}/question-content-by-template/:template_id/:category_id/`,
  version: `${rootBaseEndpoint}/version/`,
  //OverAll sentiment Analysis API endpoints
  overall_customer_sentiment: `${rootCallEvaluationEndpoint}/overall-customer-sentiment/`,
  speaker_all_emotions: `${rootCallEvaluationEndpoint}/speaker-all-emotions/`,
  top_phrases: `${rootCallEvaluationEndpoint}/top-phrases/`,
  overall_word_cloud: `${rootCallEvaluationEndpoint}/overall-word-cloud/`,
  // coaching movements endpoints
  coaching_analysis: `${rootCallEvaluationEndpoint}/coaching-analysis/`,
  compliance_adherence_rate: `${rootCallEvaluationEndpoint}/compliance-adherence-rate/`,
  behavioral_proficiency: `${rootCallEvaluationEndpoint}/coaching-mechanism/behavioral-proficiency/`,
  coaching_recommendations: `${rootCallEvaluationEndpoint}/coaching-mechanism/recommendations/`,
  actionable_insights: `${rootCallEvaluationEndpoint}/coaching-mechanism/actionable-insights/`,
  sentiment_distribution: `${rootCallEvaluationEndpoint}/sentiment-distribution/`,
  sentiment_per_call: `${rootCallEvaluationV2Endpoint}/sentiment-per-call/`,
  workflow_level_status: `${rootCallEvaluationEndpoint}/workflow-level-status/`,
  sentiment_drivers: `${rootCallEvaluationEndpoint}/sentiment/top-drivers/`,
  agent_coaching_dashboard_kpi: `${rootCallEvaluationEndpoint}/agent-performance-dashboard/`,

  // Role Management API endpoints
  create_role: `${rootAccessMgmtEndpoint}/create-role/`,
  update_role: `${rootAccessMgmtEndpoint}/update-role/`,
  delete_role: `${rootAccessMgmtEndpoint}/delete-role/`,
  role_details: `${rootAccessMgmtEndpoint}/role-details`,
  role_usage: `${rootAccessMgmtEndpoint}/role-usage`,
  role_permissions: `${rootAccessMgmtEndpoint}/role-permissions`,
  role_users: `${rootAccessMgmtEndpoint}/role-users`,
  assign_permissions_to_role: `${rootAccessMgmtEndpoint}/assign-permissions-to-role/`,
  remove_permissions_from_role: `${rootAccessMgmtEndpoint}/remove-permissions-from-role/`,
  bulk_assign_permissions_to_roles: `${rootAccessMgmtEndpoint}/bulk-assign-permissions-to-roles/`,
  bulk_remove_permissions_from_roles: `${rootAccessMgmtEndpoint}/bulk-remove-permissions-from-roles/`,

  // Automation Rule Management API endpoints
  list_automation_rules: `${rootAccessMgmtEndpoint}/list-automation-rules/`,
  automation_rule_detail: `${rootAccessMgmtEndpoint}/automation-rule-detail`,
  create_automation_rule: `${rootAccessMgmtEndpoint}/create-automation-rule/`,
  update_automation_rule: `${rootAccessMgmtEndpoint}/update-automation-rule`,
  delete_automation_rule: `${rootAccessMgmtEndpoint}/delete-automation-rule`,
  evaluate_automation_rules: `${rootAccessMgmtEndpoint}/evaluate-automation-rules/`,
  // test_automation_rule: `${rootAccessMgmtEndpoint}/test-automation-rule`,
  test_automation_rule: `${rootAccessMgmtEndpoint}/test-rule-conditions`,
  toggle_automation_rule: `${rootAccessMgmtEndpoint}/toggle-automation-rule`,
  automation_rule_usage: `${rootAccessMgmtEndpoint}/automation-rule-usage`,
  test_rule_conditions: `${rootAccessMgmtEndpoint}/test-rule-conditions/`,
  preview_rule_for_employees: `${rootAccessMgmtEndpoint}/preview-rule-for-employees/`,
  bulk_evaluate_employees: `${rootAccessMgmtEndpoint}/bulk-evaluate-employees/`,

  //Tenant Admin panel apis
  workflow_levels: `${rootBaseEndpoint}/approval-workflow-levels/`,
  approval_workflow_level_template: `${rootBaseEndpoint}/approval-workflow-level-template/`,
  approval_workflow_actions_lookup: `${rootCallEvaluationEndpoint}/lookup/approval-workflow-actions`,
  language: `${rootBaseEndpoint}/lookups/language/`,
  campaignKpis: `${rootAccountsEndpoint}/campaign-kpis/`,
  tenantDashboardKpis: `${rootBaseEndpoint}/tenant-dashboard-kpis/`,
  configurationsList: `${rootAccountsEndpoint}/entity-configuration/`,
  entity_field_mappings: `${rootAccountsEndpoint}/entity-field-mappings/`,
  //domain
  domains: `${rootBaseEndpoint}/domains/`,
  // Role Management New APIs
  roleDetail: `${rootAccessMgmtEndpoint}/role-detail/`,
  role_hierarchy_preview: `${rootAccessMgmtEndpoint}/role-hierarchy/preview/`,
  permissions: `${rootAccessMgmtEndpoint}/permissions/`,
  rolePermissionModule: `${rootAccessMgmtEndpoint}/permission-modules/`,
  roleAssignPermissions: `${rootAccessMgmtEndpoint}/assign_permissions/`,
  listPermissions: `${rootAccessMgmtEndpoint}/list-permissions/`,
  removePermissionsToRole: `${rootAccessMgmtEndpoint}/remove-permissions-from-role/`,
  permission_kpi: `${rootAccessMgmtEndpoint}/permissions_kpi/`,
  available_permissions: `${rootAccessMgmtEndpoint}/available_permissions/`,
  assigned_permissions: `${rootAccessMgmtEndpoint}/assigned_permissions/`,
  employee_available_permissions: `${rootAccessMgmtEndpoint}/employee-available-permissions/`,
  employee_assigned_permissions: `${rootAccessMgmtEndpoint}/employee-assigned-permissions/`,
  assign_permissions_to_employee: `${rootAccessMgmtEndpoint}/assign-permissions-to-employee/`,

  // Agent Performance Details
  agent_performance_detail_kpis: `${rootCallEvaluationV2Endpoint}/call-evaluation-agent-kpi/`,
  agent_performance_call_volume_vs_avg_score: `${rootCallEvaluationV2Endpoint}/call-volume-vs-score/`,
  agent_workflow_status: `${rootCallEvaluationV2Endpoint}/agent-workflow-status/`,
  failed_category_count: `${rootCallEvaluationV2Endpoint}/failed-category-count/`,
  personal_trends: `${rootCallEvaluationV2Endpoint}/personal-trends/`,
  campaign_wise_performance: `${rootCallEvaluationV2Endpoint}/campaign-wise-performance/`,
  ai_improvements_tracking_trends: `${rootCallEvaluationV2Endpoint}/ai-improvement-trend/`,
  ai_improvement_tracking: `${rootCallEvaluationV2Endpoint}/ai-improvement-tracking/`,
  agent_next_actions: `${rootCallEvaluationV2Endpoint}/agent-next-actions/`,
  agent_call_evidence: `${rootCallEvaluationV2Endpoint}/agent-call-evidence/`,
  agent_performance_improvements_and_recommendations: `${rootCallEvaluationV2Endpoint}/performance-improvements-and-recommendations/`,
  agent_achievements: `${rootCallEvaluationEndpoint}/agent-achievements/`,
  selectPrimaryRole: `${rootAccountsEndpoint}/set-primary-role/`,
  // Supervisor team performance
  performance_team_report_kpi: `${rootCallEvaluationEndpoint}/performance-team-report-kpi/`,
  performance_team_report_list: `${rootCallEvaluationEndpoint}/performance-team-report-list/`,
  ai_score_trends: `${rootCallEvaluationEndpoint}/ai-score-trends/`,
  //campaign Team wise reports
  campaign_team_performance_report_list: `${rootCallEvaluationEndpoint}/campaign-team-performance-report-list/`,
  campaign_team_performance_report_kpi: `${rootCallEvaluationEndpoint}/campaign-team-performance-report-kpi/`,
  selection_criteria: `${rootAccountsEndpoint}/selection-criteria/`,
  selection_criteria_report_types: `${rootAccountsEndpoint}/report-types/`,
  selection_criteria_call_results: `${rootAccountsEndpoint}/call-results/`,
  // Admin AI Engine Configurations CRUD and engine lookup
  ai_engine_config: `${rootAccountsEndpoint}/ai-engine-config/`,
  ai_engine_list: `${rootAccountsEndpoint}/ai_engine_list/`,
  stt_engine_config: `${rootAccountsEndpoint}/stt-engine-config/`,
  stt_source_type_lookup: `${rootAccountsEndpoint}/source-type/`,
  stt_timestamps_lookup: `${rootAccountsEndpoint}/timestamps/`,
  ce_summary_configurations: `${rootCallEvaluationEndpoint}/ce-summary-configurations/`,
  ce_summary_configuration_values: `${rootCallEvaluationEndpoint}/ce-summary-configuration-values/`,
  ce_summary_results: `${rootCallEvaluationEndpoint}/ce-summary-results/`,
  call_sampling_configuration: `${rootCallEvaluationEndpoint}/call-sampling-configuration/`,

  //pii configuration apis
  pii_configuration_list: `${rootBaseEndpoint}/pii-configurations/`,
  pii_configuration: `${rootBaseEndpoint}/pii-configuration/`,
  pii_anonymizer: `${rootBaseEndpoint}/anonymizer-types/`,
  pii_configuration_kpis: `${rootBaseEndpoint}/pii-configuration-kpis/`,

  //pii entity apis
  pii_entity_list: `${rootBaseEndpoint}/pii-entities/`,
  pii_entity: `${rootBaseEndpoint}/pii-entity/`,
  pii_entity_kpis: `${rootBaseEndpoint}/pii-entity-kpis/`,

  //pii pattern apis
  pii_pattern_list: `${rootBaseEndpoint}/pii-patterns/`,
  pii_pattern: `${rootBaseEndpoint}/pii-pattern/`,
  pii_pattern_kpis: `${rootBaseEndpoint}/pii-pattern-kpis/`,

  //pii denyterm apis
  pii_denyterm_list: `${rootBaseEndpoint}/pii-denyterms/`,
  pii_denyterm: `${rootBaseEndpoint}/pii-denyterm/`,
  pii_denyterm_kpis: `${rootBaseEndpoint}/pii-denyterm-kpis/`,
  // Analytics Module APIS
  analytics_query: `${rootAnalyticsEndpoint}/query/`,
  analytics_drilldown: `${rootAnalyticsEndpoint}/drilldown/`,
  analytics_kpi_drilldown: `${rootAnalyticsEndpoint}/kpi-drilldown/`,
  analytics_export: `${rootAnalyticsEndpoint}/export/`,
  analytics_metadata: `${rootAnalyticsEndpoint}/metadata/`,
  analytics_batch_query: `${rootAnalyticsEndpoint}/batch-query/`,
  analytics_dashboards: `${rootAnalyticsEndpoint}/dashboards/`,
  analytics_dashboard_detail: `${rootAnalyticsEndpoint}/dashboards/`,
  // Analytics Admin
  analytics_admin_custom_metrics: `${rootAnalyticsEndpoint}/admin/metrics/`,
  analytics_admin_custom_metric_preview: `${rootAnalyticsEndpoint}/admin/metrics/preview/`,
  analytics_admin_derived_metrics: `${rootAnalyticsEndpoint}/admin/derived-metrics/`,
  analytics_admin_entity_fields: `${rootAnalyticsEndpoint}/admin/entities/`,
  analytics_admin_custom_dimensions: `${rootAnalyticsEndpoint}/admin/dimensions/`,
  // Analytics Scheduled Reports (base; append <dashboard_id>/schedules/)
  analytics_dashboard_schedules: `${rootAnalyticsEndpoint}/dashboards/`,
  // Natural Language Query
  analytics_nl_query: `${rootAnalyticsEndpoint}/nl-query/`,
  analytics_nl_query_suggestions: `${rootAnalyticsEndpoint}/nl-query/suggestions/`,
  // Auto-Insights
  analytics_insights: `${rootAnalyticsEndpoint}/insights/`,
  analytics_insights_generate: `${rootAnalyticsEndpoint}/insights/generate/`,
  // Dashboard Import / Export
  analytics_dashboard_import: `${rootAnalyticsEndpoint}/dashboards/import/`,
  analytics_dashboard_import_template: `${rootAnalyticsEndpoint}/dashboards/import/template/`,
  analytics_dashboard_export: `${rootAnalyticsEndpoint}/dashboards/`,
};
